import Req from '../../$axios'

const serviceModule = {
  productSeriesIndex(params) {
    return Req(
      {
        url: '/productSeries/index',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productSeriesRead(params) {
    return Req(
      {
        url: '/productSeries/read',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productSeriesSave(params) {
    return Req(
      {
        url: '/productSeries/save',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productSeriesUpdate(params) {
    return Req(
      {
        url: '/productSeries/update',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productSeriesUpdateSort(params) {
    return Req(
      {
        url: '/productSeries/updateSort',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productSeriesDelete(params) {
    return Req(
      {
        url: '/productSeries/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  restoreSeries(params) {
    return Req(
      {
        url: '/productSeries/restoreSeries',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  seriesRecycleIndex(params) {
    return Req(
      {
        url: '/productSeries/seriesRecycleIndex',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsIndex(params) {
    return Req(
      {
        url: '/products/index',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsSave(params) {
    return Req(
      {
        url: '/products/save',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsUpdate(params) {
    return Req(
      {
        url: '/products/update',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsRead(params) {
    return Req(
      {
        url: '/products/read',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productUpdateHistoriesIndex(params) {
    return Req(
      {
        url: '/productUpdateHistories/index',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsRecycleIndex(params) {
    return Req(
      {
        url: '/products/productsRecycleIndex',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productUpdateHistoriesRed(params) {
    return Req(
      {
        url: '/productUpdateHistories/read',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsDelete(params) {
    return Req(
      {
        url: '/products/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsRestoreProduct(params) {
    return Req(
      {
        url: '/products/restoreProduct',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  productsUpdateSort(params) {
    return Req(
      {
        url: '/products/updateSort',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
}
